import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroManuntecaoVeiculo from '../../actions/manutencao-veiculo/adicionarFiltroManutencaoVeiculo'
import removerFiltroManutencaoVeiculo from '../../actions/manutencao-veiculo/removerFiltroManutencaoVeiculo'

import CampoBusca from '../comum/CampoBusca'

export class CampoBuscaManutencaoVeiculo extends Component {
  render () {
    return (
      <React.Fragment>
        <CampoBusca
          filtrosAdicionados={this.props.filtrosAdicionadosProcesso}
          adicionarFiltro={this.props.adicionarFiltroManuntecaoVeiculo}
          removerFiltro={this.props.removerFiltroManutencaoVeiculo}/>
      </React.Fragment>
    )
  }
}

export const mapStateToProps = ({ filtrosAdicionadosProcesso }) => ({ filtrosAdicionadosProcesso });

export const mapDispatchToProps = dispatch => bindActionCreators({
    adicionarFiltroManuntecaoVeiculo,
    removerFiltroManutencaoVeiculo
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CampoBuscaManutencaoVeiculo)
